// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex';
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import echarts from 'echarts'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css';
import 'echarts/theme/shine.js'
import $ from 'jquery'
import md5 from 'js-md5';
import axios from 'axios';
import { pickerOptions, labelOption } from './utils/format'
import '@/styles/index.scss' // global css
import '@/icons'
import VueWechatTitle from 'vue-wechat-title'

Vue.prototype.$axios = axios
Vue.prototype.Vuex = Vuex
Vue.prototype.echarts = echarts
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$ = $
Vue.prototype.$md5 = md5;
Vue.prototype.pickerOptions = pickerOptions
Vue.prototype.labelOption = labelOption
Vue.prototype.baseApi = process.env.BASE_API
Vue.prototype.pageTitle = process.env.PAGE_TITLE
Vue.prototype.qiniuUrl = 'https://up-z0.qiniu.com'
Vue.use(VueWechatTitle)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js